<aside class="position-fixed main-sidebar sidebar-dark-primary">
  <a href="/" class="brand-link text-center">
     <span *ngIf="tipoSaas == 2" class="brand-text font-weight-light">
      <img alt="Logo Sistema" class="img-logo" src="assets/logoMenu.png" />
    </span>
    <span *ngIf="tipoSaas != 2" class="brand-text font-weight-light">
      <img alt="Logo Sistema" class="img-logo" src="assets/logoComFundo.png" />
    </span>
  </a>
  <div class="sidebar">
    <nav class="mt-2" *ngIf="tipoSaas != 2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <li class="nav-item ">
          <a href="/" class="nav-link">
            <i class="nav-icon fa fa-home"></i>
            <div class="texto-link">Dashboard</div>
          </a>
        </li>
        <li class="nav-item">
          <a href="/juridico/agenda" class="nav-link">
            <i class="nav-icon fa fa-calendar-check-o"></i>
            <div class="texto-link">Agenda</div>
          </a>
        </li >
        <li class="nav-item">
          <a href="/cadastro/atendimento" class="nav-link">
            <i class="nav-icon fa fa-download"></i>
            <div class="texto-link">Atendimentos</div>
          </a>
        </li >
        <li class="nav-item">
          <a href="/cadastro/cliente" class="nav-link">
            <i class="nav-icon fa fa-users"></i>
            <div class="texto-link">Clientes</div>
          </a>
        </li >
        <li class="nav-item">
          <a routerLink="/empresa/financeiro" class="nav-link">
            <i class="nav-icon fa fa-money"></i>
            <div class="texto-link">Financeiro</div>
          </a>
        </li >
        <li class="nav-item">
          <a href="/juridico/tarefa/" class="nav-link">
            <i class="nav-icon fa fa-check-square"></i>
            <div class="texto-link">Tarefas</div>
          </a>
        </li>
        <li class="nav-item">
          <a href="/juridico/processo" class="nav-link">
            <i class="nav-icon fa fa-telegram"></i>
            <div class="texto-link">Processos</div>
          </a>
        </li>
        <li class="nav-item">
          <a href="/juridico/audiencia" class="nav-link">
            <i class="nav-icon fa fa-gavel"></i>
            <div class="texto-link">Audiências</div>
          </a>
        </li>
        <li class="nav-item">
          <a href="/juridico/documento-processo" class="nav-link">
            <i class="fa fa-file-pdf-o nav-icon"></i>
            <div class="texto-link">Documentos</div>
          </a>
        </li>
        <li *ngIf="token?.seguranca == 'Admin' || token?.seguranca == 'GestorAdmin'" class="nav-item">
          <a href="/auth/usuario" class="nav-link">
            <i class="fa fa-user-plus nav-icon"></i>
            <div class="texto-link">Usuários</div>
          </a>
        </li>
        <li *ngIf="token?.seguranca == 'Admin' || token?.seguranca == 'GestorAdmin'" class="nav-item">
          <a href="/cadastro/gerais" class="nav-link">
            <i class="fa fa-cog nav-icon"></i>
            <div class="texto-link">Configurações</div>
          </a>
        </li>
        <li *ngIf="token?.seguranca == 'Admin'" class="nav-item">
          <a href="/gestao" class="nav-link">
            <i class="fa fa-cogs nav-icon"></i>
            <div class="texto-link">Gestão</div>
          </a>
        </li>
      </ul>
    </nav>
    <ul class="nav nav-pills nav-sidebar flex-column sidebar-rodape">
      <li class="nav-item" style="cursor: pointer" (click)="abrirModal()">
        <a class="nav-link">
          <i class="nav-icon fa fa-comment"></i>
          <div class="texto-link">Feedback / Suporte</div>
        </a>
      </li>
      <li class="nav-item">
        <a href="/ajuda" target="_blank" class="nav-link">
          <i class="nav-icon fa fa-question"></i>
          <div class="texto-link">Ajuda</div>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" (click)="logoff()">
          <i class="nav-icon fa fa-sign-out"></i>
          <div class="texto-link">Sair</div>
        </a>
      </li>
    </ul>
  </div>
</aside>

<app-modal-feedback [(showModalFeedback)]="showModalFeedback"></app-modal-feedback>
